import { Type, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { IWidgetComponent, IWidgetComponentDefinition, AbstractWidgetDirective } from '@azavista/components/widgets';
import { WidgetDefinitionType, WidgetDefinitionDataType } from './interfaces';
import { EventsByTypeWidgetComponent } from './events-by-type/events-by-type-widget.component';
import { ParticipantsByStageWidgetComponent } from './participants-by-stage/participants-by-stage-widget.component';
import { CountdownClockWidgetComponent } from './countdown-clock/countdown-clock-widget.component';
import { ObjectCountWidgetComponent } from './object-count/object-count-widget.component';
import { ParticipantsByTypeWidgetComponent } from './participants-by-type/participants-by-type-widget.component';
import { EventWaitingListWidgetComponent } from './event-waiting-list/event-waiting-list-widget.component';
import { ActivityParticipantGroupByStatusWidgetComponent } from './activity-participant-group-by-status/activity-participant-group-by-status-widget.component';
import { SalesByProductWidgetComponent } from './sales-by-product/sales-by-product-widget.component';
import { EmailCampaignDeliveryWidgetComponent } from './email-campaign-delivery/email-campaign-delivery.component';
import { SalesByProductQuantityWidgetComponent } from './sales-by-product-quantity/sales-by-product-quantity.component';

@Injectable()
export class WidgetsService {
    widgetsToDefinitions(widgets: IWidgetComponent[], context: any): IWidgetComponentDefinition[] {
        return widgets.map((widget) => ({
            componentType: this.getComponentTypeFromWidget(widget.type, widget.dataType as WidgetDefinitionDataType),
            data: null,
            id: widget.id,
            dataType: widget.dataType,
            type: widget.type,
            title: widget.title,
            reportType: widget.reportType,
            dataChangedSubject: new Subject<any>(),
            settings: {
                local: widget.settings.local || {},
                remote: widget.settings.remote || {}
            },
            context: context
        } as IWidgetComponentDefinition));
    }

    getComponentTypeFromWidget(definitionType: string, definitionDataType: WidgetDefinitionDataType): Type<AbstractWidgetDirective> {
        if (definitionType === WidgetDefinitionType.chart) {
            if (definitionDataType === WidgetDefinitionDataType.eventsByEventType) {
                return EventsByTypeWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.participantsByEventType) {
                return ParticipantsByTypeWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.participantsByStage) {
                return ParticipantsByStageWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.countdownClock) {
                return CountdownClockWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.objectCount) {
                return ObjectCountWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.eventWaitingList) {
                return EventWaitingListWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.activityParticipantGroupByStatus) {
                return ActivityParticipantGroupByStatusWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.salesByProduct) {
                return SalesByProductWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.salesByProductQuantity) {
                return SalesByProductQuantityWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.emailCampaignDelivery) {
                return EmailCampaignDeliveryWidgetComponent;
            }
        }
        return null;
    }

    definitionsToWidgets(widgets: IWidgetComponentDefinition[]): IWidgetComponent[] {
        return widgets.map((widget) => ({
            id: widget.id,
            type: widget.type,
            dataType: widget.dataType,
            reportType: widget.reportType,
            title: widget.title,
            settings: {
                local: { ...widget.settings.local },
                remote: { ...widget.settings.remote }
            }
        }));
    }
}
